
import "./LoanRateTitle.css";
export default function LoanRateTitle({ title }) {
  return (
    <>
      <div className='loan-rate-title'>{title}</div>
    </>
  );
}